import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { GetResponseInstagramBot, InstagramAccount, InstagramCommentStats, InstagramCommentsResponse, InstagramDmStats } from '../../models/messenger-bot.interface';

export interface UpdateInstagramBotPayload {
  is_enabled?: boolean;
  comments_reply_enabled?: boolean;
  comments_reply_mode?: boolean;
  comments_predefined_message?: string | null;
  comments_trigger_type?: 'any' | 'keywords';
  comments_trigger_keywords?: string[];
  comments_reply_send_dm?: boolean;
  comments_reply_send_public?: boolean;
  comments_predefined_message_public?: string | null;
  profile_picture_url?: string | null;
  account_username?: string | null;
  account_name?: string | null;
  followers_count?: number | null;
  follows_count?: number | null;
  media_count?: number | null;
  attention_schedule_enabled?: boolean;
  attention_schedule_start_time?: string | null;
  attention_schedule_end_time?: string | null;
  away_message_enabled?: boolean;
  away_message_text?: string | null;
}

@Injectable({
  providedIn: 'root',
})
export class InstagramBotService {
  apiAddress: string = environment.apiAddress;

  constructor(private http: HttpClient) {}

  postAccountSubscription(
    botId: string,
    instagramAccount: InstagramAccount,
    linked_page_id: string,
    page_access_token: string
  ) {
    return this.http.post<any>(`${this.apiAddress}/bot/${botId}/instagram_bot`, {
      ...instagramAccount,
      linked_page_id,
      page_access_token,
    });
  }

  getBotInstagram(botId: string) {
    return this.http.get<GetResponseInstagramBot>(`${this.apiAddress}/bot/${botId}/instagram_bot`);
  }

  updateAccountSubscription(botId: string, payload: UpdateInstagramBotPayload) {
    return this.http.put<any>(`${this.apiAddress}/bot/${botId}/instagram_bot`, payload);
  }

  deleteBotInstagram(botId: string) {
    return this.http.delete<any>(`${this.apiAddress}/bot/${botId}/instagram_bot`);
  }

  initiateInstagramOAuth(chatbotId: string, returnTo?: string): void {
    const returnToParam = returnTo ? `&return_to=${encodeURIComponent(returnTo)}` : '';
    window.location.href = `${this.apiAddress}/instagram/oauth/authorize?chatbot_id=${chatbotId}${returnToParam}`;
  }

  refreshInstagramToken(chatbotId: string): Observable<any> {
    return this.http.post<any>(`${this.apiAddress}/instagram/oauth/refresh-token`, {
      chatbot_id: chatbotId,
    });
  }

  getRecentComments(botId: string, page: number = 1, pageSize: number = 6): Observable<InstagramCommentsResponse> {
    return this.http.get<InstagramCommentsResponse>(
      `${this.apiAddress}/bot/${botId}/instagram_bot/comments`,
      { params: { page: page.toString(), page_size: pageSize.toString() } }
    );
  }

  getCommentStats(botId: string, init: string, term: string): Observable<InstagramCommentStats> {
    return this.http.get<InstagramCommentStats>(
      `${this.apiAddress}/bot/${botId}/instagram_bot/comments/stats`,
      { params: { init, term } }
    );
  }

  getIgDmStats(botId: string, init: string, term: string): Observable<InstagramDmStats> {
    return this.http.get<InstagramDmStats>(
      `${this.apiAddress}/bot/${botId}/instagram_bot/dm/stats`,
      { params: { init, term } }
    );
  }
}
